var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#B1CBD9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3335 27.1667L30.8592 33.8348C31.6306 34.3747 32.0163 34.6447 32.4358 34.7493C32.8064 34.8416 33.194 34.8416 33.5645 34.7493C33.984 34.6447 34.3697 34.3747 35.1411 33.8348L44.6668 27.1667M26.9335 42.3334H39.0668C41.027 42.3334 42.0071 42.3334 42.7558 41.9519C43.4144 41.6164 43.9498 41.081 44.2854 40.4224C44.6668 39.6737 44.6668 38.6936 44.6668 36.7334V29.2667C44.6668 27.3066 44.6668 26.3265 44.2854 25.5778C43.9498 24.9192 43.4144 24.3838 42.7558 24.0482C42.0071 23.6667 41.027 23.6667 39.0668 23.6667H26.9335C24.9733 23.6667 23.9932 23.6667 23.2445 24.0482C22.586 24.3838 22.0505 24.9192 21.715 25.5778C21.3335 26.3265 21.3335 27.3066 21.3335 29.2667V36.7334C21.3335 38.6936 21.3335 39.6737 21.715 40.4224C22.0505 41.081 22.586 41.6164 23.2445 41.9519C23.9932 42.3334 24.9733 42.3334 26.9335 42.3334Z",
    stroke: "#365A6D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    stroke: "#D0E0E8",
    strokeWidth: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mailIcon.e7854901dce4a94bf622817e46a96a90.svg";
export { ForwardRef as ReactComponent };